import {DestroyRef, inject, Injectable} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {switchMap} from 'rxjs/operators';
import {EVENT_BUS} from 'src/app/shared/domain/tokens/event-bus.token';
import {EntriesChangedEvent} from 'src/app/shared/application/events/entry/entries-changed.event';
import {ApplyAccountEntriesUseCase} from "../use-cases/apply-account-entries.use-case";

@Injectable()
export class EntriesChangedSubscriber {
  private readonly destroyRef = inject(DestroyRef);
  private readonly eventBus = inject(EVENT_BUS);
  private readonly applyAccountEntries = inject(ApplyAccountEntriesUseCase);

  constructor() {
    this.eventBus.ofType(EntriesChangedEvent)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        switchMap(event => this.applyAccountEntries.execute(event.entries, event.action))
      )
      .subscribe();
  }
}
